module.exports = __webpack_public_path__ + "35fcff510dd4816a2c05fa181baa60cc.svg";